export const BLOCK_STATE = {
  lessonPlansInBlock: []
}